import { useTranslation } from 'react-i18next';
import { clsx } from 'clsx';
import { BOARD_INSTANCE_GROUP_TYPE } from 'constants/general';

import SegmentedControl from '../SegmentedControl/SegmentedControl';

import type { TBoardInstanceGroupType } from 'store/slices/valueChainMap/interfaces/IBoardInstanceGroup';
import type { ISegmentedControlOption } from '../SegmentedControl/interfaces/ISegmentedControl';
import type { IBoardGroupBySwitchProps } from './interfaces/IBoardGroupBySwitch';

import styles from './scss/BoardGroupBySwitch.module.scss';

function BoardGroupBySwitch({
  value,
  onChange,
  className,
  disabled,
  borderless = false,
}: IBoardGroupBySwitchProps) {
  const { t } = useTranslation();

  const options: ISegmentedControlOption[] = [
    { label: t('valueChainMap.groupByLocation'), value: BOARD_INSTANCE_GROUP_TYPE.GEOGRAPHIC },
    { label: t('valueChainMap.groupByBusinessStructure'), value: BOARD_INSTANCE_GROUP_TYPE.ORGANIZATIONAL },
    { label: t('valueChainMap.groupByCards'), value: BOARD_INSTANCE_GROUP_TYPE.GENERIC },
  ];

  const handleChange = (newValue: string | number) => {
    onChange(newValue as TBoardInstanceGroupType);
  };

  return (
    <div className={clsx(styles.root, className)}>
      <span className={styles.label}>{t('valueChainMap.groupBy')}</span>
      <SegmentedControl
        options={options}
        value={value}
        onChange={handleChange}
        fullWidth
        className={clsx(styles.control, borderless && styles.controlBorderless)}
        classNameItem={styles.item}
        classNameActiveItem={styles.activeItem}
        disabled={disabled}
      />
    </div>
  );
}

export default BoardGroupBySwitch;
